import { render, staticRenderFns } from "./OrsInnerToolbar.vue?vue&type=template&id=47580ec1&scoped=true&"
import script from "./OrsInnerToolbar.vue?vue&type=script&lang=js&"
export * from "./OrsInnerToolbar.vue?vue&type=script&lang=js&"
import style0 from "./OrsInnerToolbar.vue?vue&type=style&index=0&id=47580ec1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47580ec1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/workspace/orse-infra-novo-portal-frontend-ecs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VContainer,VIcon,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
